(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[30698],{

/***/ 80870:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/workspace/templates",
      function () {
        return __webpack_require__(20566);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 20566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _partials_Header__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86518);
/* harmony import */ var _partials_FooterOLD2__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93781);
/* harmony import */ var _partials_TutorialsList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45497);
/* harmony import */ var _partials_Newsletter__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46521);
/* harmony import */ var _partials_YoutubeTutorialsList__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(87218);
/* harmony import */ var _components_Templates_Index_TemplaeNewsletter__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91257);
/* harmony import */ var _components_Templates_Index_TemaplatesList__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(72457);
/* harmony import */ var constant_functions__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60538);
/* harmony import */ var _api_api__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(10107);
/* harmony import */ var _layouts_WorkspaceLayout__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(23274);
/* harmony import */ var _components_Templates_Index_TemaplatesList2__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(97852);














function templates(param) {
    var categories = param.categories, _$templates = param.templates, isLoggedIn = param.isLoggedIn;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    }, "twitter:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Tradly – Bring your Dream into Reality. API-FIRST COMMERCE."
                    }, "og:title"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Tradly – Templates"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts_WorkspaceLayout__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                isLoggedIn: isLoggedIn,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex flex-col min-h-screen overflow-hidden",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                        className: "flex-grow",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Templates_Index_TemaplatesList2__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
                                categories: categories === null || categories === void 0 ? void 0 : categories.categories,
                                templates: _$templates
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Templates_Index_TemplaeNewsletter__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
                        ]
                    })
                })
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (templates);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [87536,26281,26601,48777,433,23274,87218,82495,4513,49774,92888,40179], function() { return __webpack_exec__(80870); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);